import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { deleteCompanyInfo, deleteImageFromCompanyInfo, getCompanyInfo } from "../Store/Thunk";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import IconSvg from "../../../../SharedComponents/IconSvg";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { ClearCompanyInfoState } from "../Store";
import { CompanyInfoApiUrls } from "../API/CompanyInfoAPI";
import Overlay from "../../../../SharedComponents/Overlay";
import BreadCrumb from "../../../BreadCrumb";
import Card from "react-bootstrap/Card";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { folderEnum, GetValueByKey, imageTypeEnum } from "../../../../../Helpers/EnumHelper";
import { UpdateAlertModalData } from "../../../../SharedComponents/GeneralModals/Store";
import ContractSection from "../../../../Contracts/Components/ContractSection";
import { ContractAudience } from "../../../../Contracts/API/ContractAPI";

export default function CompanyInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.companyInfo.isLoading);
  const companyInfo = useSelector((state) => state.companyInfo);
  const token = useSelector((state) => state.auth.user.token);
  const { state } = useLocation();

  const companyId = state?.id;
  const companyName = state?.name;

  const [logo, setLogo] = useState(null);
  const [previewLogo, setPreviewLogo] = useState("");

  const [icon, setIcon] = useState(null);
  const [previewIcon, setPreviewIcon] = useState("");

  const [editorState, setEditorState] = useState("");

  const [initialMailContent, setInitialMailContent] = useState();

  useEffect(() => {
    const prevHtml = companyInfo?.mailContent
      ? companyInfo?.mailContent
      : "<p> Adaylarınıza gönderilecek mail metni içeriği giriniz.</p>";

    const contentBlock = htmlToDraft(prevHtml);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    setInitialMailContent(EditorState.createWithContent(contentState));
  }, [companyInfo?.mailContent]);

  useEffect(() => {
    if (companyId) {
      dispatch(ClearCompanyInfoState());
      dispatch(getCompanyInfo({ companyId: companyId }));
    } else {
      navigate("/company");
    }
  }, [companyId]);

  const OnEditorStateChange = (state) => {
    setEditorState(state);
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    if (logo) {
      formData.append("logo", logo);
    }
    if (icon) {
      formData.append("icon", icon);
    }

    formData.append("companyId", companyId);
    if (editorState) {
      formData.append("mailContent", draftToHtml(convertToRaw(editorState?.getCurrentContent())));
    }

    ApiHelper.xmlPostFormData(CompanyInfoApiUrls.upsertCompanyInfo, formData, token, (res) => {
      dispatch(getCompanyInfo({ companyId: companyId }));
      if (JSON.parse(res.response).statusCode !== 1) {
        dispatch(
          UpdateAlertModalData({
            isShown: true,
            header: "serverError",
            text: JSON.parse(res.response).message,
          })
        );
      }
    });
  };

  const DeleteImage = (type, imageName) => {
    const typeEnum = GetValueByKey(type, imageTypeEnum);
    dispatch(deleteImageFromCompanyInfo({ type: typeEnum, imageName: imageName, companyInfoId: companyInfo.id }));
  };

  return (
    <div>
      {isLoading && <Overlay />}
      <Form onSubmit={HandleSubmit}>
        {
          <BreadCrumb
            pageName={t("companyInfoBreadcrumbLabel")}
            backPageName={t("companiesBreadCrumbLabel")}
            backUrl="/Company"
          >
            <Row className={"justify-content-between"}>
              <Col xs={"auto"}>
                <h3>
                  {t("companyName")} : {companyName}
                </h3>
              </Col>
              <Col xs={"auto"}>
                <Row>
                  <Col>
                    <Button
                      variant="danger"
                      className={"px-4"}
                      onClick={() => {
                        dispatch(deleteCompanyInfo({ id: companyId }));
                        dispatch(ClearCompanyInfoState());
                        setPreviewLogo("");
                        setPreviewIcon("");
                      }}
                    >
                      {t("deleteButtonLabel")}
                    </Button>
                  </Col>
                  <Col>
                    <Button variant="primary" type={"submit"} className={"px-4"}>
                      {t("saveChangesButtonLabel")}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </BreadCrumb>
        }
        {/* Branding: logo and icon side by side, equal width */}
        <Row className="my-4">
          <Col xs={12} md={6} className="mb-3">
            <Card className="default-card h-100 p-3">
              <h5 className="admin-settings-input-header">{t("uploadLogo")}</h5>
              <label className="admin-setting-page-add-image-label w-100">
                <input
                  id="company-logo-input"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setLogo(file);
                      setPreviewLogo(URL.createObjectURL(file));
                    } else {
                      // Reset state if no file is selected
                      setLogo(null);
                      setPreviewLogo(null);
                    }
                  }}
                  type="file"
                  accept=".jpeg, .png, .webp, .jpg"
                  // hidden here rather than via the global #admin-excel-input rule, so these
                  // inputs can keep unique ids without depending on that shared id
                  style={{ display: "none" }}
                />
                <IconSvg icon="add-image" />

                <span> maks: 200x200 </span>
              </label>
              {(companyInfo.logoPath || previewLogo) && (
                <>
                  <div className="logo-previev-img-container">
                    <img
                      style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                      }}
                      alt={"Company Logo"}
                      src={previewLogo ? previewLogo : ApiHelper.cloudFrontURL + folderEnum.logo + companyInfo.logoPath}
                    />
                  </div>
                  <Button
                    size="sm"
                    variant="danger"
                    style={{ margin: "10px", alignSelf: "center" }}
                    title={"Delete logo"}
                    aria-label={"Delete logo"}
                    onClick={() => {
                      DeleteImage("CompanyLogo", companyInfo.logoPath);
                    }}
                  >
                    <IconSvg icon="trash-can" fill="#fff" />
                  </Button>
                </>
              )}
            </Card>
          </Col>
          <Col xs={12} md={6} className="mb-3">
            <Card className="default-card h-100 p-3">
              <h5 className="admin-settings-input-header">{t("uploadIcon")}</h5>
              <label className="admin-setting-page-add-image-label w-100">
                <input
                  id="company-icon-input"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setIcon(file);
                      setPreviewIcon(URL.createObjectURL(file));
                    } else {
                      // Reset state if no file is selected
                      setIcon(null);
                      setPreviewIcon(null);
                    }
                  }}
                  type="file"
                  accept=".jpeg, .png, .webp, .jpg"
                  // hidden here rather than via the global #admin-excel-input rule, so these
                  // inputs can keep unique ids without depending on that shared id
                  style={{ display: "none" }}
                />
                <IconSvg icon="add-image" />

                <span> maks: 60x60 </span>
              </label>
              {(companyInfo.iconPath || previewIcon) && (
                <>
                  <div className="logo-previev-img-container">
                    <img
                      alt={"Company Icon"}
                      src={previewIcon ? previewIcon : ApiHelper.cloudFrontURL + folderEnum.logo + companyInfo.iconPath}
                      style={{
                        maxWidth: "60px",
                        maxHeight: "60px",
                        width: "auto",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <Button
                    size="sm"
                    variant="danger"
                    style={{ margin: "10px", alignSelf: "center" }}
                    onClick={() => {
                      DeleteImage("CompanyIcon", companyInfo.iconPath);
                    }}
                    title={"Delete icon"}
                    aria-label={"Delete icon"}
                  >
                    <IconSvg icon="trash-can" fill="#fff" />
                  </Button>
                </>
              )}
            </Card>
          </Col>
        </Row>

        {/* Invitation mail sent to candidates. Default row margins (no mx-0), so this card
            lines up with the rows above: the row's negative margins cancel the column padding. */}
        <Row>
          <Col>
            <Card className="default-card p-3">
              <h5 className="admin-settings-input-header">{t("theTextOfTheInvitationMailSentToTheCandidate")}</h5>
              <Editor
                editorState={editorState ? editorState : initialMailContent}
                onEditorStateChange={OnEditorStateChange}
              />
            </Card>
          </Col>
        </Row>
      </Form>

      {/* Contracts live outside the form above: they are saved on their own, not by "Save changes". */}
      {companyId && (
        <>
          <ContractSection
            companyId={companyId}
            audience={ContractAudience.CompanyAdmin}
            canManage
            title={t("contractsForAdmins")}
            description={t("contractsForAdminsHint")}
          />
          <ContractSection
            companyId={companyId}
            audience={ContractAudience.Candidate}
            canManage
            title={t("contractsForCandidates")}
            description={t("contractsForCandidatesSaHint")}
          />
        </>
      )}
    </div>
  );
}
